import React, { Component } from 'react';
// import {  NavLink } from 'react-router-dom'
import './Firstsection.css'
// import '../AP css.css'
import touch1 from '../images/touch1.png'
import { Button } from 'reactstrap';
import Socialicons from './Socialicons.js';

  



class firstsection extends Component{
    
    render() {
        // const mystyle = {
        //     color: "white",
        //     backgroundColor: "DodgerBlue",}
        // const aboutstyle = {
        //     color: "white",
        //    backgroundColor: "#16001c",}

        return (

            <div  className="home">
            <div  className="" id="topContainer">
            
    <div className="container">   
        <div className="row">	 
        
            <div className="col-sm-6 box " id="hellocontent">
            <Socialicons />
                <p className="hello"> -HELLO, I'M </p>
                <p className="da" id="name">AKILO <br/> <br/><br/> <br/>  <span>PELUMI</span></p>
                <p id="majorskills"> UX Designer | Product Designer 
                    </p>
                    <Button id="letstalkbutton" type="button" variant="primary" href="#contact"><span>Lets Talk</span></Button>{''}           
                    </div>
                    
                    <div className=" " id="imagetouch1"><img src={touch1} height="560" width="420" alt=""/></div>
                    
        </div>
       
    </div>
    

    <div className="scrolldown">
    <div className="mouse"></div>
    <p className="text">Scroll</p>
    </div>
    
</div>
    



            










</div>

        );

    }
}


export default firstsection